// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugIndexRouteImport } from './routes/$slug/index'
import { Route as SlugUuidIndexRouteImport } from './routes/$slug/$uuid/index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugIndexRoute = SlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => rootRouteImport
          })
const SlugUuidIndexRoute = SlugUuidIndexRouteImport.update({
            id: '/$slug/$uuid/',path: '/$slug/$uuid/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugIndexRoute: SlugIndexRoute,SlugUuidIndexRoute: SlugUuidIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)